// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"bc0583d4","526":"a9f66948","920":"65ef5bac"}[chunkId] + ".chunk.js";
};